module.exports = __webpack_public_path__ + "img/2.7bfa98e7.png";